import { gql } from "@apollo/client";

export const EDIT_ASSISTANCE_PROGRAM = gql`
    mutation UpdateProgram(
        $idProgram: Int!
        $name: String!
        $idProgramSubtype: Int!
        $active: Boolean!
         ){
        updateProgram(
            input: {
                idProgram: $idProgram
                name: $name
                idProgramSubtype: $idProgramSubtype
                active: $active
            }
        ) {
            idSubTipoPrograma
            nombre
        }
    }
`;